import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { InfoContainer } from '@custom-components';

import { StyledCard, LargeButton } from './ActionItems.styles';

class ActionItems extends Component {
  static propTypes = {
    buttons: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        onClick: PropTypes.func,
        btnTheme: PropTypes.string
      })
    )
  };

  static defaultProps = {
    buttons: []
  };

  getButtons = (item, index) => <LargeButton key={String(index)} uppercase btnTheme="dark" {...item} />;

  render() {
    const { buttons } = this.props;

    return (
      <InfoContainer noPadding leftSubBarContents={[{ type: 'label', props: { label: 'ACTION ITEMS' } }]}>
        <StyledCard>{buttons.map(this.getButtons)}</StyledCard>
      </InfoContainer>
    );
  }
}

export default ActionItems;
